// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1ytgJ","ranges":"BmiRanges_ranges__2izw9"};